module.exports = function (Vuex) {
  return {
    install (Vue) {
      var temp = Vuex.Store.prototype.dispatch
      Vuex.Store.prototype.httpDispatch = function (options) {
        const that = this
        let loadingInstance = null
        return function () {
          // options: $loading options
          if (options) {
            loadingInstance = Vue.prototype.$loading(options)
          }
          return temp.apply(that, arguments).then(resObj => {
            loadingInstance && loadingInstance.close()
            if (!resObj.data) {
              resObj.data = {
                resType: 'error',
                code: '5000000',
                msg: 'Internal server error'
              }
              Vue.prototype.$notify.error({ title: 'Error', message: resObj.data.msg, duration: 5000 })
            }
            return resObj
          }).catch((err) => {
            loadingInstance && loadingInstance.close()
            if (err.response.status === 401) {
              localStorage.clear('token')
              localStorage.clear('tokenExpiredAt')
              Vue.prototype.$notify.error({ title: 'Error', message: 'Please login agin!', duration: 5000 })
            }
            throw err.response
          })
        }
      }
    }
  }
}
